export default "/static/media/summer.e9275caf.css";